// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class YearDataItem  {
    _originalTypeClassName = "Loom.BO.YearDataItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
YearDataItem.translate = translateService;
}
this.Year = null;
this.YearDataItemKey = null;
this._key = this.YearDataItemKey = 0; 
}

static translate: TranslateService;
_key: any;
Year:any;
private _YearDataItemKey:any;
get YearDataItemKey(): any {
    return this._YearDataItemKey;
  }
set YearDataItemKey(value: any) {
    this._YearDataItemKey = value;
    this._key = value;
  }

static GenerateYears(start: any,end: any): any{let years = [];
for (var i = start; CLMS.Framework.Number.LessThanOrEqual(() => i, () => end); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let year = new Domain.YearDataItem();year.Year = i;years?.add(year);}

return years;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.YearDataItemKey == null || $this.YearDataItemKey == 0;
            }


}